import EssealPhoneInput from "@/components/EssealPhoneInput";
import { CompanyResource } from "@/graphql/generated/graphql";
import { Tooltip } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "esseal-data-table";

const humanResourceColumns: GridColDef<CompanyResource>[] =
  [
    {
      field: "name",
      headerName: "Name",
      width: 300,
      renderCell: ({ row }: GridRenderCellParams) =>
        <Tooltip title={row.name}>
          <span>{row.name}</span>
        </Tooltip>
    },
    {
      field: "email",
      headerName: "Email",
      width: 300,
      valueGetter: (row) => row.resourceMeta?.email || "",
      renderCell: (params) => {
        return params.row.resourceMeta?.email || "";
      }
    },
    {
      field: "primaryPhone",
      headerName: "Phone",
      width: 300,
      valueGetter: (row) => row.resourceMeta?.primaryPhone || "",
      renderCell: ({ value }) => <EssealPhoneInput
        readOnly
        countryCode="GB"
        defaultValue={value}
        showCountrySelector={false}
        theme={{ colorBorder: 'transparent', colorBg: 'transparent' }}
      />,
    },
    {
      field: "bio",
      headerName: "Bio",
      width: 300,
      renderCell: (params) => {
        return params.row.resourceMeta?.bio || "";
      }
    }
  ];

export default humanResourceColumns;
